import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography'; // Make sure to replace with the correct path to your image
import Deer from './Deer';
import Turkey from './Turkey';

function Welcome() {
  return (
    <Box id="home-section" component="section" py={{ xs: 0, lg: 7 }}>
      <Container sx={{ pb: { xs: 12, lg: 10 }, pt: 12 }}>
        <Grid
          container
          item
          flexDirection="column"
          alignItems="center"
          xs={12}
          md={8}
          sx={{ mx: 'auto', textAlign: 'center' }}
        >
          <Typography variant="h1" id="Hunts" color="black" mb={2}>
            Guided Deer & Turkey Hunts in Georgia!
          </Typography>
          <Typography
            variant="body2"
            color="black"
            sx={{ fontSize: '1.25rem' }}
          >
            Experience the thrill of hunting trophy whitetail deer in the heart
            of Georgia. For years, our hunters have successfully bagged their
            biggest bucks on our guided hunts. Whether you're after your first
            deer or a new personal best, we offer the ultimate deer hunting
            experience. Our loyal clients return season after season to enjoy
            hunting in South Georgia's prime deer habitat. What's our secret?
            It's the combination of expert guides, premium locations, and
            guaranteed success!
          </Typography>
        </Grid>
      </Container>
      <Deer />
      <Turkey />
      {/* <Box component={'section'} py={{ xs: 0, lg: 7 }}>
        <Container>
          <Box position="relative">
            <Grid container spacing={3} justifyContent="center">
              <Grid size={{ xs: 12, md: 3 }}>
                <HuntCard
                  title="Deer"
                  description="Enjoy a guided hunt with expert guides in prime locations."
                  img={DeerImage}
                  subtitle="Experience the thrill of hunting trophy whitetail deer in the heart of Georgia."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 3 }}>
                <HuntCard
                  title="Turkey"
                  description="Enjoy a guided hunt with expert guides in prime locations."
                  img={TurkeyImage}
                  subtitle="Experience the thrill of hunting turkey in the heart of Georgia."
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box> */}
    </Box>
  );
}
export default Welcome;
